import { antiNameHandler } from 'module/anti_name_handler';
import CustomLinearProgress from 'module/custom_linear_progress';
import strings from '../../strings/strings.json'

interface Props {
    av_name: string
    av_data: any
}
export default function AvCard(props: Props) {
    return (
        <div className='w-full border border-gray-200 p-2 rounded-lg'>
            {/* top */}
            <div className='flex justify-between items-center'>
                <div className='primary_text_color font-medium'>
                    {props.av_data.progress[`${props.av_name}`] ?
                        props.av_data.progress[`${props.av_name}`]
                        :
                        0
                    }%
                </div>
                <div className='flex justify-center items-center'>
                    <span className='VazirEng'>{antiNameHandler(props.av_name)}</span>
                    <img className='w-6 h-6 mr-1' src={require(`../../assets/icons/${props.av_name}.png`)} alt="Icon" />
                </div>
            </div>
            {/* bottom */}
            <div className='flex flex-col'>
                <span
                    className='VazirEng secondry_text_color text-xs w-64 truncate mt-1'
                >
                    {(Object.keys(props.av_data.current_file).length !== 0 && props.av_data.current_file[`${props.av_name}`]) ?
                        <span dir='ltr' title={props.av_data.current_file[`${props.av_name}`]}>{props.av_data.current_file[`${props.av_name}`]}</span>
                        :
                        strings.public_scanning}
                </span>
                <div className='rotate-180 mt-2'><CustomLinearProgress value={props.av_data.progress[`${props.av_name}`]} /></div>
            </div>
        </div>
    )
}
